import {GrDocumentExcel} from "react-icons/gr";
import React from "react";

const ExcelDownloadButton = (props) => {
  return (
    <GrDocumentExcel style={{ fontSize: '25px', cursor: "pointer" }} title={props.title} className="react-icons green standard" onClick={props.onClick}/>
  )
};

export default ExcelDownloadButton;
